<script lang="ts" setup>
import { computed, ref, toRefs, watch } from 'vue';
import VModal from '@shared/component/VModal/VModal.vue';
import ProductSelectie from '@product-lib/components/ProductSelectie.vue';
import { SUREbusinessCommonDomainDoelgroepEnum as Doelgroep } from '@services/producten-public/orval-api/model/sUREbusinessCommonDomainDoelgroepEnum';
import { usePakkettenGetPakket } from '@services/producten-public/orval-api/pakketten-api/pakketten-api';

import { usePakketpolisStore } from '../pakketpolisStore';

const props = defineProps<{
  pakketpolisnummer: string;
  pakketId?: string | null;
  huidigeProducten: Record<string, number>;
  adviseurnummer: number;
}>();

const { pakketId } = toRefs(props);

const isOpen = defineModel<boolean>('isOpen');

const doelgroep = ref<Doelgroep>(Doelgroep.MKB);

const pakketpolisStore = usePakketpolisStore();

const selectedProducts = ref<Record<string, number>>({});

const numberOfProducts = computed(() =>
  Object.values(selectedProducts.value).reduce((total, num) => total + num, 0),
);

const { data: pakket } = usePakkettenGetPakket(pakketId, {
  query: {
    select: (q) => q.result,
  },
});

watch(pakket, (p) => {
  if (p?.doelgroepen.length === 1) doelgroep.value = p.doelgroepen[0].code as Doelgroep;
});

function decrease(productId: string) {
  selectedProducts.value[productId] === 1
    ? delete selectedProducts.value[productId]
    : selectedProducts.value[productId]--;
}

function increase(productId: string) {
  selectedProducts.value[productId]
    ? selectedProducts.value[productId]++
    : (selectedProducts.value[productId] = 1);
}

function onConfirm() {
  Object.entries(selectedProducts.value).forEach((sp) => {
    pakketpolisStore.addProduct(props.pakketpolisnummer, sp[0], sp[1]);
  });
  selectedProducts.value = {};
  isOpen.value = false;
}
</script>
<template>
  <VModal
    data-testid="product-toevoegen-modal"
    title="Product toevoegen"
    invert-header
    @close-modal="isOpen = false"
    @confirm-action="onConfirm()"
    :disabled="numberOfProducts === 0"
    :is-active="isOpen"
    :confirm-button-text="
      numberOfProducts > 1 ? `${numberOfProducts} producten toevoegen` : 'Product toevoegen'
    "
  >
    <ProductSelectie
      class="max-h-[75dvh]"
      @product-increased="increase"
      @product-decreased="decrease"
      :adviseurnummer="adviseurnummer"
      :current-products="huidigeProducten"
      :pakket-id="pakketId"
      :selected-products="selectedProducts"
      :doelgroep="doelgroep"
      :doelgroepen="pakket?.doelgroepen"
    />
  </VModal>
</template>
